import styles from "./style.module.scss";

export default function TooltipText() {
  return (
    <p className={styles.tooltipText}>
      <b>Note:</b> <br />
      Folder must follow the required structure. In addition, make sure images
      and file contents match, otherwise, the folder will be marked as invalid.
    </p>
  );
}
